import { useHasPermission } from '@components/WithPermissions'
import { CaseImportQuarantineCountDocument, Permission } from '@gql'
import { useQuery } from '@hooks/graphql'
import { LeadQueueTab } from '@sections/leadQueues/urls'

/** Refresh cadence for the backlog numbers — counts, not a live feed. */
const POLL_INTERVAL_MS = 60_000

export type LeadQueueBacklog = Record<LeadQueueTab, number> & { total: number }

/**
 * Open backlog per tab, and their sum for the single nav badge. The count is
 * 0 — and its query never issued — for anyone lacking MANAGE_CASES, so the
 * badge counts exactly the work its owner can actually do.
 */
export function useLeadQueueBacklog(): LeadQueueBacklog {
  const canWorkQuarantine = useHasPermission([Permission.MANAGE_CASES])

  const { data } = useQuery(CaseImportQuarantineCountDocument, {
    fetchPolicy: 'cache-and-network',
    pollInterval: POLL_INTERVAL_MS,
    skip: !canWorkQuarantine,
  })

  const quarantine = data?.caseImportQuarantineCount ?? 0

  return {
    [LeadQueueTab.quarantine]: quarantine,
    total: quarantine,
  }
}

export default useLeadQueueBacklog
